
import * as React from "react";
import { motion } from "framer-motion";

const Security = (props) => {
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width={84}
      height={84}
      fill="none"
      {...props}
    >
      <motion.path
        fill="#051A2F"
        fillRule="evenodd"
        d="M41.596 4.333c-3.25 0-6.353 1.062-11.358 2.777l-2.521.863c-5.135 1.758-9.098 3.114-11.935 4.267-1.429.58-2.658 1.142-3.647 1.717-.952.553-1.907 1.242-2.556 2.167-.641.914-.973 2.037-1.181 3.119-.217 1.124-.347 2.473-.432 4.021C7.8 26.34 7.8 30.551 7.8 36.014v5.553c0 21.148 15.973 31.288 25.472 35.438l.094.04c1.178.515 2.285.999 3.557 1.325 1.343.343 2.77.49 4.674.49 1.904 0 3.331-.147 4.674-.49 1.273-.326 2.38-.81 3.557-1.325l.095-.04c9.499-4.15 25.472-14.29 25.472-35.438v-5.552c0-5.464 0-9.676-.168-12.75-.084-1.55-.215-2.898-.431-4.023-.209-1.08-.54-2.204-1.182-3.118-.648-.925-1.603-1.614-2.556-2.167-.989-.575-2.218-1.137-3.646-1.717-2.837-1.153-6.8-2.51-11.935-4.267l-2.522-.863c-5.005-1.715-8.108-2.777-11.358-2.777Zm-10.12 7.849c5.597-1.916 7.84-2.65 10.12-2.65 2.28 0 4.524.734 10.12 2.65l1.986.68c5.243 1.794 9.067 3.104 11.752 4.195 1.34.544 2.31 1 2.992 1.396.337.196.569.357.723.483.132.106.181.167.189.176.006.01.05.083.11.253.07.195.146.473.221.861.152.786.266 1.865.345 3.32.16 2.917.16 6.987.16 12.562v5.459c0 17.939-13.415 26.768-22.354 30.673-1.288.562-2.031.88-2.86 1.092-.79.203-1.755.329-3.384.329s-2.594-.126-3.384-.329c-.828-.211-1.572-.53-2.86-1.092-8.939-3.905-22.354-12.734-22.354-30.673v-5.459c0-5.575.001-9.645.16-12.561.08-1.456.194-2.535.346-3.32.074-.389.151-.668.22-.862.061-.17.104-.242.11-.253.008-.009.058-.07.19-.176.154-.126.386-.287.723-.483.681-.395 1.652-.852 2.992-1.396 2.685-1.09 6.509-2.4 11.752-4.196l1.986-.68Z"
        clipRule="evenodd"
        initial={{ opacity: 1, scale: 1 }}
        animate={{  scale: [1, 1.05, 1] }}
        transition={{
          duration: 2,
          ease: "easeInOut",
          repeat: Infinity, 
          repeatType: "mirror", 
        }}
      />
      <motion.path
        fill="#051A2F"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.664 41.597a19.931 19.931 0 1 1 39.863 0 19.931 19.931 0 0 1-39.863 0Zm19.737-14.671c.12-.06.18-.061.195-.061.015 0 .074 0 .195.06.13.065.331.2.588.465.53.548 1.137 1.496 1.705 2.917.56 1.4 1.028 3.124 1.352 5.082a36.63 36.63 0 0 1 .41 3.608h-8.5c.08-1.24.218-2.452.41-3.608.324-1.958.791-3.681 1.351-5.082.569-1.421 1.176-2.369 1.706-2.917.257-.266.458-.4.588-.464Zm-9.264 12.071c.087-1.522.25-3.02.489-4.458.335-2.02.817-3.92 1.439-5.604a14.736 14.736 0 0 0-6.97 10.062h5.042Zm-5.042 5.2h5.042c.087 1.521.25 3.019.489 4.457.335 2.021.817 3.92 1.439 5.605a14.728 14.728 0 0 1-6.97-10.062Zm29.002-5.2a14.72 14.72 0 0 0-4.084-7.817 14.731 14.731 0 0 0-2.886-2.245c.622 1.684 1.104 3.584 1.439 5.604a42.09 42.09 0 0 1 .489 4.458h5.042Zm-5.042 5.2h5.042a14.719 14.719 0 0 1-4.084 7.817 14.724 14.724 0 0 1-2.886 2.245c.622-1.684 1.104-3.584 1.439-5.605.238-1.438.402-2.936.489-4.457Zm-5.21 0a36.627 36.627 0 0 1-.409 3.607c-.324 1.959-.791 3.682-1.352 5.083-.568 1.42-1.176 2.369-1.705 2.917-.257.265-.459.4-.588.464a.443.443 0 0 1-.195.061.443.443 0 0 1-.195-.06c-.13-.065-.331-.2-.588-.465-.53-.548-1.137-1.496-1.706-2.917-.56-1.4-1.027-3.124-1.351-5.083a36.627 36.627 0 0 1-.41-3.607h8.5Z"

        initial={{ rotate: 0 }}
        animate={{ rotate: [0, 5, -5, 0] }} 
        transition={{
          duration: 4, 
          ease: "easeInOut",
          repeat: Infinity,
          repeatType: "loop", 
        }}
      />
    </motion.svg>
  );
};

export default Security;
